export default __webpack_public_path__ + "static/media/stride_img.ae678fcc.png";